export const projectDetails = {
  'rights-of-nature': {
    eyebrow: 'Longperson advocacy',
    heroTitle: 'Rights of Nature',
    heroSummary: 'NAIWA Daughters is helping lead a Cherokee-rooted movement to recognize Longperson — the waterways — as a living being with inherent rights, cultural dignity, and legal protection.',
    heroImage: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/4x1ve2mz_Honoring%20Longperson.png',
    supportingImage: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/t6o101np_613425394_856524667077775_7651948833175231163_n.jpg',
    cards: [
      { title: 'Resolution 91 (2026)', body: 'The Eastern Band of Cherokee Indians formally recognized rights for Longperson, centering Cherokee values, water protection, and Tribal sovereignty.' },
      { title: 'Task Force Action', body: 'A Rights of Nature Task Force is charged with implementation planning, public education, and restoration recommendations.' },
      { title: 'Community Education', body: 'The project connects youth leadership, public storytelling, and ceremony with real-world policy advocacy.' },
    ],
    rights: [
      'The right to exist, persist, and regenerate free from negative human disturbance.',
      'The right to remain free from pollution, contamination, invasive species, and environmental degradation.',
      'The right to serve as a home and habitat for non-human relatives.',
      'The right to maintain free-flowing conditions without harmful obstruction.',
      'The right to be protected under Eastern Band of Cherokee laws, customs, and traditions.',
    ],
    faq: [
      { question: 'What does Rights of Nature mean?', answer: 'It recognizes ecosystems as living beings with legal rights to exist, thrive, and regenerate instead of treating them only as property.' },
      { question: 'Why does it matter for Cherokee communities?', answer: 'It reflects longstanding Cherokee teachings of respect, reciprocity, relationship, and responsibility toward the natural world.' },
      { question: 'What is Longperson?', answer: 'Longperson is the living embodiment of the waterways, originating in the mountains and flowing to the sea while carrying prayers, guidance, and life.' },
      { question: 'Is this a new Cherokee idea?', answer: 'No. The values are ancient. What is new is the effort to codify those values into enforceable protections against pollution, overuse, and destruction.' },
    ],
    actionItems: [
      'Support public education and water protection initiatives.',
      'Encourage policy and legal frameworks that protect Longperson.',
      'Participate in restoration, cleanup, and river-centered community action.',
      'Share Cherokee-led Rights of Nature learning with other Indigenous communities and allies.',
    ],
    documents: [
      { title: 'Resolution 91 (2026) PDF', url: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/0yhi6v5k_Res%2091%202026.pdf' },
      { title: 'Rights of Nature FAQ PDF', url: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/ijya63gt_RON%20FAQ.pdf' },
    ],
    facebookEmbeds: [
      'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fnaiwadaughterscherokee%2Fposts%2Fpfbid0XgLkB9zah28PJsi8gRR31z63YhsMAjuTdTqyJEcrVJuuddouZWWvtsrNNNQSbHKEl&show_text=true&width=500',
      'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fnaiwadaughterscherokee%2Fposts%2Fpfbid02JrjDBy6yzSgVDZ6ESBCvhMQJkBhaXbjXxB3XfQ2hWXZTcnyDqaEs5VNkATkQdJbNl&show_text=true&width=500',
    ],
    gallery: [
      {
        src: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/xs5bjbmd_Screenshot_20260223-131251.png',
        caption: 'Communication Liaison providing Land Acknowledgement and RON address at Public Lands Event',
        objectPosition: 'center',
      },
      {
        src: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/b3wuvx8r_PXL_20250916_174301234.jpg',
        caption: 'NAIWA Daughters members hosting longperson clean up event',
        objectPosition: 'center',
      },
      {
        src: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/bhwfbe8o_Screenshot%202025-10-07%20155538.png',
        caption: 'NAIWA Daughters members Leading an Outdoor Economy Conference Rights of Nature Session',
        objectPosition: 'center',
      },
    ],
  },
  'softball-for-sovereignty': {
    eyebrow: 'Sport as sovereignty',
    heroTitle: 'Softball for Sovereignty',
    heroSummary: 'This initiative builds a long-term Indigenous youth softball pathway in Cherokee, pairing sport with leadership, healing, visibility, and future education and career opportunities.',
    heroImage: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/8u96thp5_nd%20softball%20for%20sovereignty.png',
    backgroundImage: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/4jpt700e_2025-08-17%20173224.png',
    cards: [
      { title: 'Immediate Goal', body: 'Build a pathway of Indigenous youth softball programming in Cherokee that supports holistic development and prepares players for future education and careers.' },
      { title: 'Long-Term Goal', body: 'Confront systemic issues affecting Native women by raising the social value of Indigenous women through visibility, leadership, and empowerment in sport.' },
      { title: 'Broader Mission', body: 'Create a blueprint that can pour into sister tribes across Indian Country, with EBC serving as a hub for replication, mentorship, and shared sovereignty ventures in women’s sports.' },
    ],
    sections: [
      {
        title: 'Expanded partnerships and presence',
        bullets: [
          'Expanded partnership with the Atlanta Braves for shared field development and investment.',
          'Grow the regional and national presence of EBC through sport, higher education, and business.',
          'Intentionally expand EBC venture capital to prioritize investing in Indian Country.',
        ],
      },
      {
        title: 'Expanded program pathways',
        bullets: [
          'Launch the NAIWA Daughters softball team as the cultural and athletic entry point.',
          'Embed leadership development, service projects, and cultural enrichment into team activities.',
          'Host annual softball clinics with collegiate athletics to bring elite coaching to Cherokee.',
          'Create a regional showcase event drawing scouts and spotlighting EBC athletes.',
          'Partner with the Congressional Women’s Softball Team for youth leadership development and visibility in DC.',
        ],
      },
      {
        title: 'Linking sport to healing and empowerment',
        bullets: [
          'Visibility and prestige help counter cycles of violence, erasure, and vulnerability tied to MMIW and domestic violence.',
          'Participation in youth sports is linked to delayed sexual activity, stronger self-esteem, and reduced teen pregnancy.',
          'Athletics help address obesity, sedentary lifestyles, and substance abuse risk while strengthening whole-person wellness.',
          'Girls who play sports show 1.5–2.5x lower rates of depression and anxiety and report stronger meaning, purpose, and peer relationships.',
          'Around 80% of Fortune 500 female executives surveyed played sports in their earlier years.',
        ],
      },
    ],
    spotlightQuote: 'Around 80% of Fortune 500 female executives surveyed played sports in their earlier years.',
    tryoutVideo: 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/8nb4tat9_nd%20softball%20tryouts%20.mp4',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/livhfnic_PXL_20250718_190632566.RAW-01.MP.COVER.jpg',
      'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/8ovywofl_PXL_20250720_024342016.RAW-01.COVER.jpg',
      'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/b661l350_PXL_20250720_023941493.RAW-01.COVER.jpg',
      'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/slfadr2a_PXL_20250720_025600900.RAW-01.COVER.jpg',
    ],
  },
};